import EmptyState from "./EmptyState.tsx";

// Both are picked in the workspace switcher at the top of the sidebar.
const COPY = {
  org: {
    title: "No organization selected",
    body: "Pick an organization from the workspace menu at the top of the sidebar, or ask an admin to add you to one.",
  },
  tenant: {
    title: "No tenant selected",
    body: "Pick a tenant from the workspace menu at the top of the sidebar, or ask an admin to add you to one.",
  },
} as const;

/** Shown in place of a page that needs a selected organization or tenant. */
export default function NoSelectionPrompt({ kind }: { kind: "org" | "tenant" }) {
  const { title, body } = COPY[kind];
  return <EmptyState variant="panel" title={title} description={body} />;
}
